


















































import Vue from "vue";
import { LoginService, RequestService } from "@/services";

const loginService = new LoginService();
const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  components: {
  },
  data: function() {
    return {
      input: {
        username: "",
        email: "",
      },
      msgError: "",
      msgTitle: "",
      passwordRecovered: false,
    };
  },

  methods: {
    login: function() {
      const vm = this as any;
      vm.$router.push({ name: 'login' });
    },
    recuperoPassword: async function() {
      const vm = this as any;
      vm.startLoading();

      const serviceCallReturnValue = await loginService.recuperoPassword(vm.input)
        .then((result: any) => {
          vm.passwordRecovered = true;
          vm.openModal('Successo', 'Riceverai a breve una email con le istruzioni per completare il recupero della password.', []);
        })
        .catch((error) => {
          console.log(error);
          vm.openModal('Errore', 'Dati non validi');
        });

      vm.stopLoading();
    },
    getUser: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.$router.push({ name: 'home', params: {user: result}});
        })
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    openModal(title: string, msg: string) {
      const vm = this as any;
      vm.msgTitle = title;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error-login");
    },
    closeModal() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error-login");
      if (vm.passwordRecovered) {
        vm.login();
      }
    },
    onClickReturn() {
      const vm = this as any;
      vm.closeModal();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
  },
});
